module.exports = __webpack_public_path__ + "static/Gapsi1-9f0d4880c5101234968e0a9811c4095b.png";